import { useMemo } from 'react';
import { htmlToText } from 'html-to-text';

type Props = {
  contentBlocks: {
    title: string;
  }[];
};

export const useDescription = ({ contentBlocks }: Props) => {
  const keyTakeaways = contentBlocks.find((c) => c.title === 'Key Takeaways');

  return useMemo(() => {
    if (!keyTakeaways) return '';
    const text = htmlToText(
      // @ts-expect-error - FIXME
      keyTakeaways,
      {
        wordwrap: false,
        ignoreHref: true,
        selectors: [
          {
            selector: 'ul',
            format: 'unorderedList',
            options: {
              itemPrefix: ' ',
            },
          },
          {
            selector: 'a',
            format: 'anchor',
            options: {
              ignoreHref: true,
            },
          },
        ],
      }
    );
    return text.split('\n')[0];
  }, [keyTakeaways]);
};
